$(function(){
    const menuMobileImprovedSettings = {
        classes: {
            menuMobileImprovedClass: 'menu-mobile-improved-legacy--STATUS',
            navLinkIconStatusClass: "menu-mobile-improved-legacy__nav-icon--STATUS",
            navItem: "menu-mobile-improved-legacy__nav-item--PLACEHOLDER"
        },
        selectors: {
            customLogoContainerSelector: '.custom-logo-container',
            headerContentSelector: '.header',
            headerStickyContentSelector: '.header',
            menuMobileImprovedSelector: '.menu-mobile-improved-legacy',
            navItemWithDropdown: '.menu-mobile-improved-legacy__nav-item--has-dropdown',
            navLinkIconSelector: '.menu-mobile-improved-legacy__nav-icon',
            navLinkSelector: '.menu-mobile-improved-legacy__nav-link',
            oldMenuButtonSelector: '.menu-mobile-button',
            oldMenuSelector: '#menu-mobile',
            sliderContainerSelector: '.menu-mobile-improved-legacy__sub-nav-items-container',
            specificNavItemSelector: '.menu-mobile-improved-legacy__nav-item.menu-mobile-improved-legacy__nav-item--has-dropdown[data-item-index="PLACEHOLDER"]',
            specificNavItemNotSelector: `.menu-mobile-improved-legacy__nav-item.menu-mobile-improved-legacy__nav-item--has-dropdown:not([data-item-index="PLACEHOLDER"])`,
            subLinkContainerSelector: `.menu-mobile-improved-legacy__sub-link-container`,
            utilityBarSelector: `#header .utility-bar`
        },
        htmlElements: {
            navLink: `<a class="menu-mobile-improved-legacy__nav-link" data-status="closed">
                        <div class="menu-mobile-improved-legacy__nav-icon menu-mobile-improved-legacy__nav-icon--closed">
                            <span></span>
                            <span></span>
                            <span></span>
                            <span></span>
                        </div>
                    </a>`
        },
        strings: {
        }
    }

    const navTopPosition = function(type){
        let fixedHeaderContentHeight = document.querySelector(`${menuMobileImprovedSettings.selectors.headerContentSelector}`).offsetHeight;
        let stickyHeaderContentHeight = document.querySelector(`${menuMobileImprovedSettings.selectors.headerStickyContentSelector}`).offsetHeight;        
        let tempUtilityBar = document.querySelector('.toggle-header__utility-bar').offsetHeight;

        let updateMenuPosition = function() {
            let headerContentHeight = window.scrollY > fixedHeaderContentHeight ? stickyHeaderContentHeight : fixedHeaderContentHeight - window.scrollY;
            
            let hideScrollElement = document.querySelector('.header.header-drop.ease-animation-slow.hide.scroll');
            let topPosition = window.scrollY > 200 ? headerContentHeight - 1 : headerContentHeight + tempUtilityBar;
            
            document.querySelector(`${menuMobileImprovedSettings.selectors.menuMobileImprovedSelector}`).style.top = `${topPosition}px`;
        };

        if(type == "utility-bar-close"){
            headerContentHeight = stickyHeaderContentHeight;
        }
        updateMenuPosition();
        window.addEventListener('scroll', updateMenuPosition);
    }


    const initNavStyling = function(type){
        navTopPosition(type);
    }

    const menuMobileThrottle = function(func) {
        var timer;
        return function(event) {
            if (timer) clearTimeout(timer);
            timer = setTimeout(func, 250, event);
        };
    };

    const handleNavItemClick = function(e, type, itemIndex){
        e.preventDefault();

        window.Branch.nav.handleUpdateSrcSet(e, '.menu-mobile-improved-legacy__sub-nav-item-image', '.menu-mobile-improved-legacy__nav-item', 360);

        let targetItem = type == 'click_outside' ?  document.querySelectorAll(`${menuMobileImprovedSettings.selectors.specificNavItemSelector.replace('PLACEHOLDER', '1')}`)[0] : document.querySelectorAll(`${menuMobileImprovedSettings.selectors.specificNavItemSelector.replace('PLACEHOLDER', `${itemIndex}`)}`)[0];
        let value = type == 'click_outside' ? 'open' : targetItem.getAttribute('data-status');
        let index = targetItem.getAttribute('data-item-index');
        let items = document.querySelectorAll(`${menuMobileImprovedSettings.selectors.specificNavItemSelector.replace('PLACEHOLDER', `${index}`)}`);
        let allOtherItems = document.querySelectorAll(`${menuMobileImprovedSettings.selectors.specificNavItemNotSelector.replace('PLACEHOLDER', `${index}`)}`);
        let newValue = value == 'closed' ? 'open' : 'closed';
       
        items.forEach((item) => {
            let itemSubLinkContainer = item.querySelector(`${menuMobileImprovedSettings.selectors.subLinkContainerSelector}`);

            if(allOtherItems.length > 0) {
                allOtherItems.forEach((singleItem) => {
                    let singleItemSubLinkContainer = singleItem.querySelector(`${menuMobileImprovedSettings.selectors.subLinkContainerSelector}`);

                  
                    if(singleItemSubLinkContainer){
                        singleItemSubLinkContainer.setAttribute('data-status', "closed");
                        setTimeout(function () {
                            singleItem.classList.remove(`${menuMobileImprovedSettings.classes.navItem.replace('PLACEHOLDER', 'open')}`);
                            singleItem.classList.add(`${menuMobileImprovedSettings.classes.navItem.replace('PLACEHOLDER', 'closed')}`);
                            singleItem.setAttribute('data-status', 'closed');
                        }, 200);
                    } 
                    else {
                        singleItem.classList.remove(`${menuMobileImprovedSettings.classes.navItem.replace('PLACEHOLDER', 'open')}`);
                        singleItem.classList.add(`${menuMobileImprovedSettings.classes.navItem.replace('PLACEHOLDER', 'closed')}`);
                        singleItem.setAttribute('data-status', 'closed');
                    }
                    // singleItem.closest(`${stickyATCSettings.selectors.openCloseButtonContainerSelector}`).setAttribute('data-value', 'closed');
                })
            }


            item.style.pointerEvents = "none";
            if(itemSubLinkContainer && newValue == "closed"){
                itemSubLinkContainer.setAttribute('data-status', newValue);
                setTimeout(function () {
                    item.classList.remove(`${menuMobileImprovedSettings.classes.navItem.replace('PLACEHOLDER', 'open')}`);
                    item.classList.remove(`${menuMobileImprovedSettings.classes.navItem.replace('PLACEHOLDER', 'closed')}`);
                    item.setAttribute('data-status', newValue);
                    // button.closest(`${menuMobileImprovedSettings.selectors.openCloseButtonContainerSelector}`).setAttribute('data-value', newValue);
                    item.classList.add(`${menuMobileImprovedSettings.classes.navItem.replace('PLACEHOLDER', newValue)}`);
                    setTimeout(function () {
                        item.style.pointerEvents = "";
                    }, 200);

                }, 200);
            } else if(itemSubLinkContainer && newValue == "open") {
                item.classList.remove(`${menuMobileImprovedSettings.classes.navItem.replace('PLACEHOLDER', 'open')}`);
                item.classList.remove(`${menuMobileImprovedSettings.classes.navItem.replace('PLACEHOLDER', 'closed')}`);
                item.setAttribute('data-status', newValue);
                // button.closest(`${menuMobileImprovedSettings.selectors.openCloseButtonContainerSelector}`).setAttribute('data-value', newValue);
                item.classList.add(`${menuMobileImprovedSettings.classes.navItem.replace('PLACEHOLDER', newValue)}`);
                

                setTimeout(function () {
                    if(itemSubLinkContainer && newValue == "open"){
                        itemSubLinkContainer.setAttribute('data-status', newValue);
                        setTimeout(function () {
                            item.style.pointerEvents = "";
                        }, 200);
                    }
                }, 200);
            } else {
                item.classList.remove(`${menuMobileImprovedSettings.classes.navItem.replace('PLACEHOLDER', 'open')}`);
                item.classList.remove(`${menuMobileImprovedSettings.classes.navItem.replace('PLACEHOLDER', 'closed')}`);
                item.setAttribute('data-status', newValue);
                // button.closest(`${menuMobileImprovedSettings.selectors.openCloseButtonContainerSelector}`).setAttribute('data-value', newValue);
                item.classList.add(`${menuMobileImprovedSettings.classes.navItem.replace('PLACEHOLDER', newValue)}`);                
                        setTimeout(function () {
                            item.style.pointerEvents = "";
                        }, 200);

            }
        })
      
    }

    const initUtilityBarObserver = function(){
        let utilityBar = document.querySelector(`${menuMobileImprovedSettings.selectors.utilityBarSelector}`);
        let mutating = false;

        var observer = new MutationObserver(function(mutations) {
            mutations.forEach(function(mutation) {
                if (mutation.type === "attributes" && mutating == false) {
                    mutating = true;
                    initNavStyling('utility-bar-close')
                    setTimeout(function() {
                        mutating = false;
                    }, 500);
                }
            });
        });
    
        if(utilityBar){
            observer.observe(utilityBar, {attributes: true});
        }
    }

    const initNavItemSlider = function(navItemIndex){
          var swiper = new Swiper(`${menuMobileImprovedSettings.selectors.sliderContainerSelector}[data-item-index="${navItemIndex}"]`, {
            slidesPerView: 2.5,
            spaceBetween: 20,
            freeMode: true
          });

    }

    const initNavItemState = function(){
        let navItemsWithDropdown = document.querySelectorAll(`${menuMobileImprovedSettings.selectors.navItemWithDropdown}`);
        if(navItemsWithDropdown.length > 0){
            navItemsWithDropdown.forEach((navItemWithDropdown) => {
                navItemWithDropdown.querySelector('.menu-mobile-improved-legacy__nav-item-link').addEventListener('click', function(e){
                        handleNavItemClick(e, 'click', parseInt(navItemWithDropdown.getAttribute('data-item-index')))
                    }
                )
            initNavItemSlider(navItemWithDropdown.getAttribute('data-item-index'));
            })
        }

    }

    window.Branch = window.Branch || {};
    window.Branch.nav = window.Branch.nav || {};

    window.Branch.nav.initMenuMobileImproved = function(){
        if(document.querySelectorAll('.menu-mobile-improved-legacy').length > 0){
           initNavItemState(); 
           if (document.readyState !== 'loading') {
            initNavStyling();
            initUtilityBarObserver();
           } else {
            window.addEventListener("DOMContentLoaded", function() {
                initNavStyling();
                initUtilityBarObserver();
            });
           }
           window.Branch.collection.updateAllBundleBuilderGridTiles('menu-item', '.menu-mobile-improved-legacy__sub-nav-item-image-title-outer-container');
            window.addEventListener("resize", menuMobileThrottle(() => initNavStyling()));
            window.addEventListener("scroll", menuMobileThrottle(() => initNavStyling()));  
        }  
    }

    // window.addEventListener('load', function(){
    //     this.window.Branch.nav.initMenuMobileImproved();
    // });
});
